import { formatDateWithDayjs } from "../../../../utils/utils";
import { CURRENCY_FORMAT } from "../../../../utils/constants/appConstants";

export const COLUMNS = [
  {
    Header: "FEE ADJUST REPAY",
    Footer: "FEE ADJUST REPAY",
    accessor: "feeCharged",
    Cell: ({ value }) => {
      if (value !== null && value !== undefined) {
        return `${CURRENCY_FORMAT}${value}`;
      } else {
        return "";
      }
    }
  },
  {
    Header: "FEE ADJUST TODAY",
    Footer: "FEE ADJUST TODAY",
    accessor: "feeAsOfToday",
    Cell: ({ value }) => {
      if (value !== null && value !== undefined) {
        return `${CURRENCY_FORMAT}${value}`;
      } else {
        return "";
      }
    }
  },
  {
    Header: "DATE",
    Footer: "DATE",
    accessor: "completedAt",
    Cell: ({ value }) => {
      if (value) {
        return formatDateWithDayjs(value, "DD-MMM-YYYY");
      } else {
        return "";
      }
    }
  },
  {
    Header: "COMMENT",
    Footer: "COMMENT",
    accessor: "comment"
  }
];
